import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/elements/buttons/Button';
import DisconnectShopifyModal
  from 'components/dashboard/integrations/shopify/DisconnectShopifyModal';

import './DisconnectShopifyStoreButton.css';

const DisconnectShopifyStoreButton = ({ disconnectShopifyStore, disabled }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const _onDisconnect = () => {
    const form = new FormData();
    form.append('provider_name', 'shopify');
    disconnectShopifyStore(form);
  };

  return (
    <Fragment>
      <Button
        className="disconnect-shopify-store-button__component"
        onClick={() => { setModalOpen(true); }}
        disabled={disabled}
      >
        Disconnect Shopify integration
      </Button>
      <DisconnectShopifyModal
        open={modalOpen}
        onClose={() => setModalOpen(false) }
        onDisconnect={_onDisconnect}
      />
    </Fragment>
  );
};

DisconnectShopifyStoreButton.propTypes = {
  disconnectShopifyStore: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

DisconnectShopifyStoreButton.defaultProps = {
  disabled: null,
};

export default DisconnectShopifyStoreButton;
